<template>
    <v-layout row wrap>
        <v-flex>
            <div class="content-not-verified-dashboard">
                <e-icon-error size="35" class="content-not-verified-dashboard__icon"/>
                <e-typography-body-small class="content-not-verified-dashboard__info">
                    {{$t('modules.blocks.content.m-block-content-not-verified-dashboard.info')}}
                </e-typography-body-small>
            </div>
        </v-flex>
        <v-flex>
            <div class="content-not-verified-dashboard__action">
                <e-link-item disabled @click="resendConfirmationEmail" >{{$t('modules.blocks.content.m-block-content-not-verified-dashboard.link.text')}}</e-link-item>
                <e-progress-circular-primary v-show="$wait.waiting(keys.auth.verification_email)" class="content-not-verified-dashboard__action-loader"/>
            </div>
        </v-flex>
    </v-layout>
</template>

<script>
    import {mapActions} from 'vuex'
    import vuexKeys from '@mixins/includes/_vuexKeys';
    import notifications from "@mixins/includes/_notifications";
    export default {
        name: "m-block-content-not-verified-dashboard",
        mixins:[vuexKeys, notifications],
        methods:{
            ...mapActions({
                'sendConfirmationEmail':'auth/sendUserVerificationEmail',
                'checkVerification':'auth/checkVerification'
            }),
            async resendConfirmationEmail(){
                if(this.$wait.waiting(this.keys.auth.verification_email)) return;
                await this.sendConfirmationEmail(this.$user.attributes);
                this.notify.success(this.$t('notifications.registration.letterSent', {email:this.$user.attributes.email}))
            }
        },
        created(){
            this.checkVerification();
        }
    }
</script>

<style scoped lang="scss">
    .content-not-verified-dashboard{
        display: flex;
        align-items: center;
        &__icon{
            margin-right: 15px;
        }
        &__info{
            margin-bottom: 0;
        }
        &__action{
            display: flex;
            align-items: center;
            flex-wrap: nowrap;
            &-loader{
                margin-left: 15px;
            }
        }
    }

</style>
